/*
 * Copyright (C) 2018 Paymentus Inc.
 *
 * All rights reserved.
 *
 * The source code in this file is confidential and is the sole property of
 * Paymentus Inc. Its use is restricted to those readers who are authorized by
 * the corporation. Any reverse engineering or reproduction or divulgence of the
 * content of this report without the written consent from Paymentus Inc. is
 * strictly prohibited.
 *
 * Created on 8/20/18 2:30 PM
 * Created by kxian
 *
 */
import React from "react";
import OnePagePayment from './rotp-opp';
import AppStateHolder from "../components/app-state-holder";
import DevWidget from "../components/dev-widget";
import {model as config} from "../lib/ext-refs";
import {INITIAL_STATE, resetData, prepopulatePartialPayment} from "../lib/payment-utils";
import {customizationLoader} from "../lib/loadable";
import Loadable from "react-loadable";
import {hot} from "react-hot-loader";

const appLoader = (tla, app) => {
    return Loadable({
        loader() {
            return customizationLoader((tla || '').toLowerCase(), app);
        },
        loading() {
            return <div>Loading...</div>;
        },
        render(data, _) {
            const initialState = INITIAL_STATE,
                devMode = (process.env.NODE_ENV !== 'production');
            // Initialize the first payment only when there is not state yet
            // otherwise we loose the state with Hot Reload.
            if (initialState.payments.length === 0) {
                resetData(initialState, config);
                prepopulatePartialPayment(initialState, config);
            }
            return (
                <AppStateHolder
                    initialState={initialState}
                    config={config}
                    app={OnePagePayment}
                    devWidget={devMode && DevWidget}
                    appComponents={data}
                />
            );
        }
    });
};

export default hot(module)(appLoader(config.tla, 'ropp'));